<template>
  <div class="flex-1 mt-1 bg-gray-100 px-4 pt-12 shadow-lg items-center">
    <div class="bg-white w-fullrounded-lg shadow">
      <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-2">
        <div class="flex">
          <router-link
            :class="$colors.primary"
            class="rounded-full flex justify-center items-center w-8 h-8 mt-1 mr-3"
            to="/warehouses"
          >
            <i class="material-icons mx-2">chevron_left</i>
          </router-link>
          <div v-if="!formData._id" class="text-2xl font-bold text-green-500 ">
            {{$t('new_warehouse')}}
          </div>
          <div v-else class="text-2xl font-bold text-green-500 ">{{$t('edit_warehouse')}}</div>
        </div>
      </div>
        <div class="bg-white rounded-lg p-6 pt-2">
          <div class="grid lg:grid-cols-2 gap-6">
             <div class="border hover:border-green-500  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <p>
                         <label for="name" class="bg-white text-gray-700 px-1">
                     {{$t('name')}} <span :class="$colors.required">*</span></label
                  >
                      </p>
                    </div>
                    <p>
                     <input
                      id="name"
                      :placeholder="$t('warehouse_name')"
                      tabindex="0"
                      type="text"
                      v-model="formData.name"
                      class="py-2 text-xs px-2 outline-none block h-full w-full"
                />
                    </p>
              </div>
                <div
              class="border hover:border-green-500  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1"
            >
              <div
                class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
              >
                <p>
                  <label for="country" class="bg-white text-gray-700 px-1"
                    >{{$t('country')}}</label
                  >
                </p>
              </div>
              <p>
                <v-select
                  @input="setSelectedContry"
                  v-model="formData.country"
                  :options="options"
                  label="name"
                >
                  <template slot="option" slot-scope="option">
                    <img
                      class="flag-img"
                      :src="$f.getCountryCode(option.code)"
                    />
                    {{ option.name }} 
                  </template>
                </v-select>
              </p>
            </div>
            <!--   <div
                    class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                  >
                    <p>
                      <label for="zone" class="bg-white text-gray-700 px-1"
                        >{{$t('zone')}}<span :class="$colors.required">
                          *</span
                        ></label
                      >
                    </p>
                  </div>
                  <div
                    id="city"
                    class="md:w-full overflow-y-auto h-full flex flex-col items-center p-1"
                  >
                    <div class="w-full">
                      <div class="flex flex-col  relative">
                        <div class="items">
                            <label v-for="(item,index) in zones" :key="index" class="inline-flex items-center">
                               <input :id="item._id" @change='getRowDetail(item._id)' type="checkbox" :class="'rowCheckboxZone-'+item._id" class="form-checkbox h-5 w-5 text-green-600"><span class="ml-2 font-medium text-gray-800">{{item.name}}</span>
                            </label>
                        </div>
                       
                      </div>
                    </div>
                  </div>-->
           </div> 
          <div class="grid lg:grid-cols-2 gap-6 pt-10">
            <div class="border hover:border-green-500  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <p>
                         <label for="parent" class="bg-white text-gray-700 px-1">
                   Parent warehouse</label
                  >
                      </p>
                    </div>
                    <p>
                    <v-select
                     :disabled="(formData._id && formData.is_primary)||!formData.country"
                      @input="setSelectedParent"
                      v-model="formData.parent"
                      :options="warehouses"
                      label="countryName"
                  >
                  <template slot="option" slot-scope="option">
                    <img
                      class="flag-img"
                      :src="option.flag"
                    />
                    {{ option.countryName }}
                  </template>
                </v-select>
                    </p>
              </div>
             <div v-if="!formData.parent" class="border hover:border-green-500  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <p>
                         <label for="currency" class="bg-white text-gray-700 px-1">
                     {{$t('currency')}} <span :class="$colors.required">*</span></label
                  >
                      </p>
                    </div>
                    <p>
                     <input
                      id="currency"
                      :placeholder="$t('warehouse_currency')"
                      tabindex="0"
                      type="text"
                      v-model="formData.currency"
                      class="py-2 text-xs px-2 outline-none block h-full w-full"
                />
                    </p>
              </div>
             

              <div v-if="formData.parent" class="border hover:border-green-500  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <p>
                         <label for="Zones" class="bg-white text-gray-700 px-1">
                     {{$t('Zones')}} <span :class="$colors.required">*</span></label
                  >
                      </p>
                    </div>
                    
                    <p>
                      <v-select label="name" v-model="formData.zones"  :options="zones" multiple ></v-select>
                    </p>
              </div>

          </div>  
          <!-- ===== Réglages avancés (Call Center + Auto-Confirm) déplacés dans une modale à onglets ===== -->
          <!-- Settings entry point. Reports BOTH engines: the native rule gate and
               the AI agent. The old button only knew about the native one, so a
               warehouse confirming orders with the AI still read as off. -->
          <div v-if="formData._id && !formData.parent" class="whx-entry" @click="openSettingsModal('callcenter')">
            <div class="whx-entry-ico">
              <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"
                   stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <circle cx="12" cy="12" r="3"/>
                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06A1.65 1.65 0 0 0 15 19.4a1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09A1.65 1.65 0 0 0 15 4.6a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
              </svg>
            </div>

            <div class="whx-entry-txt">
              <div class="whx-entry-t">{{$t('advanced_settings')||'Réglages Call Center & Auto-Confirmation'}}</div>
              <div class="whx-entry-s">Qui confirme les commandes de cet entrepôt, et comment.</div>

              <div class="whx-entry-pills">
                <!-- native rule gate -->
                <span v-if="formData.autoConfirm_settings && formData.autoConfirm_settings.enabled"
                      class="whx-p on">Règle native · {{ formData.autoConfirm_settings.mode || 'strict' }}</span>
                <span v-else class="whx-p off">Règle native OFF</span>

                <!-- AI agent: live actually confirms, shadow only watches -->
                <span v-if="formData.aiCallCenter && formData.aiCallCenter.active && formData.aiCallCenter.mode === 'live'"
                      class="whx-p on">Agent IA live · {{ Math.round((formData.aiCallCenter.threshold || 0.85) * 100) }}%</span>
                <span v-else-if="formData.aiCallCenter && formData.aiCallCenter.active"
                      class="whx-p watch">Agent IA shadow</span>
                <span v-else class="whx-p off">Agent IA OFF</span>
              </div>
            </div>

            <svg class="whx-entry-arrow" viewBox="0 0 24 24" width="18" height="18" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="9 18 15 12 9 6"/>
            </svg>
          </div>

          <vue-modal-2 v-if="formData._id && !formData.parent" name="warehouseSettingsModal" :headerOptions="{title: ($t('advanced_settings')||'Réglages Call Center & Auto-Confirmation')}" :noFooter="true" modalSize="xl" @on-close="$vm2.close('warehouseSettingsModal')">
          <!-- Pas d'overflow interne : vue-modal-2 scrolle déjà (max-height 90vh) — sinon double scrollbar -->
          <div class="p-4">

            <!-- Tabs: SVG icons (emoji render per-platform) and a filled active
                 state, plus a dot that says which engines are actually running -->
            <div class="whx-tabs">
              <button type="button" class="whx-tab" :class="{on: settingsTab==='callcenter'}" @click="settingsTab='callcenter'">
                <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor"
                     stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                <span>Call Center</span>
              </button>
              <button type="button" class="whx-tab" :class="{on: settingsTab==='autoconfirm'}" @click="settingsTab='autoconfirm'">
                <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor"
                     stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
                </svg>
                <span>{{$t('auto_confirm')||'Auto-Confirm'}}</span>
                <span class="whx-sub">natif</span>
                <span v-if="formData.autoConfirm_settings && formData.autoConfirm_settings.enabled" class="whx-dot on"></span>
              </button>
              <button type="button" class="whx-tab" :class="{on: settingsTab==='aiagent'}" @click="settingsTab='aiagent'">
                <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor"
                     stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <rect x="4" y="8" width="16" height="12" rx="2"/><path d="M12 8V4"/><circle cx="12" cy="3" r="1"/>
                  <path d="M9 13h.01M15 13h.01M9 17h6"/>
                </svg>
                <span>Agent IA</span>
                <span v-if="formData.aiCallCenter && formData.aiCallCenter.active"
                      class="whx-dot" :class="formData.aiCallCenter.mode==='live' ? 'on' : 'watch'"></span>
              </button>
            </div>

            <!-- ===== TAB CALL CENTER ===== -->
            <div v-show="settingsTab==='callcenter'">

          <!-- Bouton d'aide Call Center -->
          <div class="flex justify-end mb-3">
            <button type="button" @click="$vm2.open('callcenterHelpModal')" class="text-xs flex items-center gap-1 border border-blue-400 text-blue-700 px-3 py-1 rounded hover:bg-blue-50">
              <i class="material-icons" style="font-size:14px">help_outline</i> Comment ça marche ?
            </button>
          </div>

          <div class="grid lg:grid-cols-2 gap-6">

            <div class="whx-panel">
              <div class="whx-panel-h">
                <span class="whx-panel-t">Traitement des Orders <span :class="$colors.required">*</span></span>
                <span class="whx-panel-n">Les statuts que ce call center traite, dans l&rsquo;ordre</span>
              </div>
              <div class="whx-panel-b">
                <v-select @input="setSelectedStatus" multiple placeholder="Type orders ..."  v-model="formData.callcenter" label="name" :options="params_callcenter" class="capitalize callcenter-select"></v-select>
                <div v-if="formData.callcenter.length>1" class="flex items-center gap-1 mt-3 px-2 py-1.5 text-xs text-blue-700 bg-blue-50 rounded">
                  <i class="material-icons" style="font-size:14px">info_outline</i>
                  <span>Ordre: <b>{{ formData.callcenter.map(e=> e.name).join(' → ') }}</b></span>
                </div>
              </div>
            </div>

            <div class="whx-panel">
              <div class="whx-panel-h">
                <span class="whx-panel-t">Pending Unreached</span>
                <span class="whx-panel-n">Cadence de rappel avant abandon</span>
              </div>
              <div class="whx-panel-b grid grid-cols-2 gap-4">
                <div>
                  <label class="text-xs text-gray-600 mb-1 block font-medium">Appels / jour</label>
                  <input type="number" min="1" v-model.number="formData.pending_unreached.nb_perDay" class="py-2 text-sm px-3 outline-none block w-full border border-gray-200 rounded focus:border-green-500" />
                  <p class="text-xs text-gray-400 mt-1">Max tentatives par commande par jour.</p>
                </div>
                <div>
                  <label class="text-xs text-gray-600 mb-1 block font-medium">Délai entre appels (min)</label>
                  <input type="number" min="1" v-model.number="formData.pending_unreached.timeMinutes" class="py-2 text-sm px-3 outline-none block w-full border border-gray-200 rounded focus:border-green-500" />
                  <p class="text-xs text-gray-400 mt-1">Pause minimum entre 2 tentatives.</p>
                </div>
                <div>
                  <label class="text-xs text-gray-600 mb-1 block font-medium">Max appels total</label>
                  <input type="number" min="1" v-model.number="formData.pending_unreached.nbCalls" class="py-2 text-sm px-3 outline-none block w-full border border-gray-200 rounded focus:border-green-500" />
                  <p class="text-xs text-gray-400 mt-1">Nombre max d'appels au total. La commande sort de la file après.</p>
                </div>
                <div>
                  <label class="text-xs text-gray-600 mb-1 block font-medium">Pendant (jours)</label>
                  <input type="number" min="1" v-model.number="formData.pending_unreached.nb_days" class="py-2 text-sm px-3 outline-none block w-full border border-gray-200 rounded focus:border-green-500" />
                  <p class="text-xs text-gray-400 mt-1">Jours avant passage auto en Unreached.</p>
                </div>
              </div>
            </div>

           </div>
            </div>
            <!-- ===== /TAB CALL CENTER ===== -->

            <!-- ===== TAB AUTO-CONFIRM ===== -->
            <div v-show="settingsTab==='autoconfirm'">
          <div v-if="formData.autoConfirm_settings" class="space-y-6">

            <!-- Bouton d'aide -->
            <div class="flex justify-end">
              <button type="button" @click="$vm2.open('autoConfirmHelpModal')" class="text-xs flex items-center gap-1 border border-blue-400 text-blue-700 px-3 py-1 rounded hover:bg-blue-50">
                <i class="material-icons" style="font-size:14px">help_outline</i> {{$t('how_it_works')||'Comment ça marche ?'}}
              </button>
            </div>


            <!-- Toggle + mode -->
            <div class="grid lg:grid-cols-2 gap-6">
              <label class="flex items-center gap-3 border rounded p-3 cursor-pointer">
                <input type="checkbox" v-model="formData.autoConfirm_settings.enabled" class="form-checkbox h-5 w-5 text-green-600">
                <span class="text-sm font-medium">{{$t('enable_auto_confirm')||'Activer l\'auto-confirmation'}}</span>
              </label>
              <div class="border rounded p-1 relative">
                <div class="-mt-4 absolute px-1 text-xs"><label class="bg-white text-gray-700 px-1">{{$t('mode')||'Mode'}}</label></div>
                <v-select v-model="formData.autoConfirm_settings.mode" :options="autoConfirmModes" :reduce="o=>o.value" label="label" :clearable="false" class="text-xs"></v-select>
              </div>
            </div>

            <div v-if="formData.autoConfirm_settings.enabled" class="space-y-6">

              <!-- Quick Setup -->
              <div class="whx-quick">
                <div class="flex items-center justify-between">
                  <span class="whx-quick-t">{{$t('quick_setup')||'Quick Setup (seuils suggérés)'}}</span>
                  <button type="button" @click="loadAutoConfirmPresets" :disabled="autoConfirmSaving" class="text-xs bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 disabled:opacity-50">
                    {{ autoConfirmSaving ? '...' : ($t('recompute')||'Recalculer les seuils') }}
                  </button>
                </div>
                <!-- Presets + Voir la data : toujours visibles (pas besoin de cliquer "Calculer") -->
                <div class="mt-3 flex flex-wrap gap-2 items-center">
                  <button type="button" v-for="k in ['conservative','balanced','aggressive']" :key="k" @click="applyAutoConfirmPreset(k)"
                    :class="autoConfirmActivePreset===k
                      ? 'bg-green-600 text-white border-green-700 ring-2 ring-green-300 shadow font-semibold'
                      : 'bg-white border-green-400 text-green-700 hover:bg-green-50'"
                    class="text-xs border-2 px-3 py-1 rounded-full capitalize transition-all flex items-center gap-1">
                    <span v-if="autoConfirmActivePreset===k">✓</span>{{k}}
                  </button>
                  <span v-if="autoConfirmActivePreset" class="text-xs text-green-700 italic">✓ {{$t('preset_active')||'preset appliqué'}}</span>
                  <button type="button" @click="openAutoConfirmPreview" :disabled="autoConfirmPreviewLoading" class="text-xs border border-blue-400 text-blue-700 px-3 py-1 rounded hover:bg-blue-100 disabled:opacity-50 ml-auto">
                    {{ autoConfirmPreviewLoading ? '...' : ('👁 '+($t('see_data')||'Voir la data')) }}
                  </button>
                  <div v-if="autoConfirmPresets && autoConfirmPresets.counts" class="w-full text-xs text-gray-500 mt-2">
                    {{autoConfirmPresets.counts.excellentCustomers}} clients excellents · {{autoConfirmPresets.counts.trustedProducts}} produits fiables · {{autoConfirmPresets.counts.trustedSellers}} vendeurs fiables
                  </div>
                </div>
              </div>

              <!-- Le preview data s'affiche dans une modale paginée (voir #autoConfirmPreviewModal) -->

              <!-- Seuils CLIENT (mode STRICT : le client seul décide) -->
              <div v-if="formData.autoConfirm_settings.mode==='strict'">
                <p class="text-xs font-medium text-gray-700 mb-2">👤 {{$t('customer_criteria')||'Critères client (mode strict)'}}</p>
                <div class="grid lg:grid-cols-2 gap-6">
                  <div class="border rounded p-1 relative">
                    <div class="-mt-4 absolute px-1 text-xs"><label class="bg-white text-gray-700 px-1">{{$t('strict_min_delivered')||'Client : min. livraisons'}}</label></div>
                    <input type="number" min="1" v-model.number="formData.autoConfirm_settings.strictMinDelivered" class="py-2 text-xs px-2 outline-none block w-full">
                  </div>
                  <div class="border rounded p-1 relative">
                    <div class="-mt-4 absolute px-1 text-xs"><label class="bg-white text-gray-700 px-1">{{$t('strict_max_return')||'Client : max. taux retour %'}}</label></div>
                    <input type="number" min="0" max="100" v-model.number="formData.autoConfirm_settings.strictMaxReturnRate" class="py-2 text-xs px-2 outline-none block w-full">
                    <p class="text-xxs text-gray-400 px-1">{{$t('return_rate_hint')||'= retournées ÷ total expéditions × 100'}}</p>
                  </div>
                </div>
              </div>

              <!-- Seuil CLIENT minimal pour les modes Produit/Vendeur -->
              <div v-if="formData.autoConfirm_settings.mode!=='strict'">
                <p class="text-xs font-medium text-gray-700 mb-2">👤 {{$t('customer_criteria_relaxed')||'Critère client (mode produit/vendeur)'}}</p>
                <div class="grid lg:grid-cols-2 gap-6">
                  <div class="border rounded p-1 relative">
                    <div class="-mt-4 absolute px-1 text-xs"><label class="bg-white text-gray-700 px-1">{{$t('relaxed_min_delivered')||'Client : min. livraisons'}}</label></div>
                    <input type="number" min="0" placeholder="1" v-model.number="formData.autoConfirm_settings.relaxedMinDelivered" class="py-2 text-xs px-2 outline-none block w-full">
                    <p class="text-xxs text-gray-400 px-1">{{$t('relaxed_min_hint')||'Livraisons réussies min. du client avant de regarder les produits. 0 = accepter tout client.'}}</p>
                  </div>
                </div>
              </div>

              <!-- Fenêtres d'activité (récence) -->
              <div class="border rounded p-3 bg-gray-50">
                <p class="text-xs font-medium text-gray-700 mb-1">⏱ {{$t('activity_windows')||'Fenêtres d\'activité (mois)'}}</p>
                <p class="text-xxs text-gray-400 mb-3">{{$t('activity_windows_hint')||'Le client/produit/vendeur doit avoir eu une activité dans les N derniers mois pour être auto-confirmé. Vide = pas de limite (tout l\'historique compte).'}}</p>
                <div class="grid lg:grid-cols-2 gap-6">
                  <div class="border rounded p-1 relative bg-white">
                    <div class="-mt-4 absolute px-1 text-xs"><label class="bg-white text-gray-700 px-1">{{$t('strict_window')||'Activité client (mois)'}}</label></div>
                    <input type="number" min="1" max="24" placeholder="—" v-model.number="formData.autoConfirm_settings.strictDateRangeMonths" class="py-2 text-xs px-2 outline-none block w-full">
                  </div>
                  <div v-if="formData.autoConfirm_settings.mode==='phone+product+seller'" class="border rounded p-1 relative bg-white">
                    <div class="-mt-4 absolute px-1 text-xs"><label class="bg-white text-gray-700 px-1">{{$t('seller_window')||'Vendeur risqué : activité (mois)'}}</label></div>
                    <input type="number" min="1" max="24" placeholder="—" v-model.number="formData.autoConfirm_settings.sellerRiskyDateRangeMonths" class="py-2 text-xs px-2 outline-none block w-full">
                  </div>
                </div>
              </div>

              <!-- Critère PRODUIT (seul le taux de livraison décide) -->
              <div v-if="formData.autoConfirm_settings.mode!=='strict'">
                <p class="text-xs font-medium text-gray-700 mb-2">📦 {{$t('product_criteria')||'Critère produit (tous les produits de la commande)'}}</p>
                <div class="grid lg:grid-cols-2 gap-6">
                  <div class="border rounded p-1 relative">
                    <div class="-mt-4 absolute px-1 text-xs"><label class="bg-white text-gray-700 px-1">{{$t('product_min_delivery')||'Produit : min. taux livraison %'}}</label></div>
                    <input type="number" min="0" max="100" v-model.number="formData.autoConfirm_settings.productTrustedMinDeliveryRate" class="py-2 text-xs px-2 outline-none block w-full">
                    <p class="text-xxs text-gray-400 px-1">{{$t('delivery_rate_hint')||'= livrées ÷ total expéditions × 100'}}</p>
                  </div>
                </div>
              </div>

              <!-- Vendeur risqué -->
              <div v-if="formData.autoConfirm_settings.mode==='phone+product+seller'" class="grid lg:grid-cols-2 gap-6">
                <div class="border rounded p-1 relative">
                  <div class="-mt-4 absolute px-1 text-xs"><label class="bg-white text-gray-700 px-1">{{$t('seller_risky_min_ship')||'Vendeur risqué : min. expéditions'}}</label></div>
                  <input type="number" min="1" v-model.number="formData.autoConfirm_settings.sellerRiskyMinShippings" class="py-2 text-xs px-2 outline-none block w-full">
                </div>
                <div class="border rounded p-1 relative">
                  <div class="-mt-4 absolute px-1 text-xs"><label class="bg-white text-gray-700 px-1">{{$t('seller_risky_max_return')||'Vendeur risqué : max. taux retour %'}}</label></div>
                  <input type="number" min="0" max="100" v-model.number="formData.autoConfirm_settings.sellerRiskyMaxReturnRate" class="py-2 text-xs px-2 outline-none block w-full">
                </div>
              </div>

              <!-- Garde-fou clients "Orange money" (à transférer) -->
              <div class="border rounded p-3 bg-yellow-50">
                <p class="text-xs font-medium text-yellow-800 mb-2">🔴 {{$t('transfer_guard')||'Clients souvent injoignables (passés en "Orange money")'}}</p>
                <div class="grid lg:grid-cols-2 gap-6">
                  <div class="border rounded p-1 relative bg-white">
                    <div class="-mt-4 absolute px-1 text-xs"><label class="bg-white text-gray-700 px-1">{{$t('min_orange_orders')||'Nb. de commandes "Orange money" pour bloquer'}}</label></div>
                    <input type="number" min="1" placeholder="—" v-model.number="formData.autoConfirm_settings.minTransferOrders" class="py-2 text-xs px-2 outline-none block w-full">
                    <p class="text-xxs text-gray-400 px-1">{{$t('min_orange_orders_hint')||'Le client n\'est PAS auto-confirmé s\'il a atteint ce nombre de commandes passées en Orange money. Vide = garde-fou désactivé.'}}</p>
                  </div>
                </div>
              </div>

              <!-- SMS -->
              <div class="border rounded p-3">
                <label class="flex items-center gap-3 cursor-pointer mb-3">
                  <input type="checkbox" v-model="formData.autoConfirm_settings.sms.enabled" class="form-checkbox h-5 w-5 text-green-600">
                  <span class="text-sm font-medium">{{$t('sms_confirmation')||'SMS de confirmation'}}</span>
                </label>
                <div v-if="formData.autoConfirm_settings.sms.enabled" class="space-y-3">
                  <div class="border rounded p-1 relative">
                    <div class="-mt-4 absolute px-1 text-xs"><label class="bg-white text-gray-700 px-1">{{$t('sms_sender')||'Nom expéditeur (vide = défaut)'}}</label></div>
                    <input type="text" maxlength="30" v-model="formData.autoConfirm_settings.sms.senderName" class="py-2 text-xs px-2 outline-none block w-full">
                  </div>
                  <div class="border rounded p-1 relative">
                    <div class="-mt-4 absolute px-1 text-xs"><label class="bg-white text-gray-700 px-1">{{$t('sms_template')||'Modèle SMS'}}</label></div>
                    <textarea maxlength="500" rows="3" v-model="formData.autoConfirm_settings.sms.template" class="py-2 text-xs px-2 outline-none block w-full"></textarea>
                    <p class="text-xs text-gray-400 px-1">Placeholders: {customerName} {orderId} {totalPrice} {currency}</p>
                  </div>
                </div>
              </div>

              <!-- Info créneau -->
              <div class="flex w-full items-center p-2 text-xs text-blue-800 rounded-lg bg-blue-50">
                <svg class="flex-shrink-0 inline w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20"><path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"></path></svg>
                <span>{{$t('period_info')||'Créneau de livraison : les commandes auto-confirmées sont planifiées au créneau habituel du client (matin → 10:00, après-midi → 15:00).'}}</span>
              </div>

            </div>
          </div>
            </div>
            <!-- ===== /TAB AUTO-CONFIRM ===== -->

            <!-- ===== TAB AGENT IA (separate tab from native auto-confirm) ===== -->
            <div v-show="settingsTab==='aiagent'">
            <div v-if="formData.aiCallCenter" class="ai-panel">
              <!-- header band -->
              <div class="ai-panel-head">
                <div class="ai-avatar">🤖</div>
                <div class="ai-head-txt">
                  <div class="ai-head-title">Agent IA — Call-Center <span class="ai-chip">fallback</span></div>
                  <div class="ai-head-sub">Distinct de l'auto-confirm natif ci-dessus. L'IA agit <b>en second</b> : elle confirme uniquement les commandes laissées <b>Pending</b> par le gate natif, sans signal de fraude, via la réputation <b>cross-projet</b>.</div>
                </div>
                <label class="ai-switch" :class="{on: formData.aiCallCenter.active}">
                  <input type="checkbox" v-model="formData.aiCallCenter.active" class="sr-only">
                  <span class="ai-switch-track"><span class="ai-switch-dot"></span></span>
                </label>
              </div>

              <!-- how the two systems relate -->
              <div class="ai-flow">
                <span class="ai-flow-step native">1 · Gate natif <em>confirme ce qu'il connaît</em></span>
                <span class="ai-flow-arrow">→</span>
                <span class="ai-flow-step ai">2 · Reste Pending ? <em>l'IA tente via réputation</em></span>
              </div>

              <!-- body (only when active) -->
              <div v-if="formData.aiCallCenter.active" class="ai-panel-body">
                <!-- mode -->
                <div class="ai-field">
                  <div class="ai-field-label">Mode</div>
                  <div class="ai-seg">
                    <button type="button" @click="formData.aiCallCenter.mode='shadow'"
                      :class="{active: formData.aiCallCenter.mode==='shadow'}" class="ai-seg-btn shadow">
                      <b>Shadow</b><small>observe · gratuit</small>
                    </button>
                    <button type="button" @click="formData.aiCallCenter.mode='live'"
                      :class="{active: formData.aiCallCenter.mode==='live'}" class="ai-seg-btn live">
                      <b>Live</b><small>confirme · facturé</small>
                    </button>
                  </div>
                  <p v-if="formData.aiCallCenter.mode==='live'" class="ai-warn">
                    ⚠️ L'IA confirmera réellement les commandes (facturé par commande <b>processed</b>). Nécessite aussi <code>AC_SHADOW=false</code> côté serveur.
                  </p>
                </div>

                <div class="ai-grid">
                  <!-- threshold -->
                  <div class="ai-field">
                    <div class="ai-field-label">Seuil de confiance <span class="ai-val">{{Math.round((formData.aiCallCenter.threshold||0.85)*100)}}%</span></div>
                    <input type="range" min="0.5" max="0.99" step="0.01" v-model.number="formData.aiCallCenter.threshold" class="ai-range">
                    <div class="ai-range-scale"><span>50% · plus d'automatisation</span><span>99% · plus sûr</span></div>
                  </div>
                  <!-- price (fixed) -->
                  <div class="ai-field">
                    <div class="ai-field-label">Prix / commande processed <span class="ai-fixed">fixe</span></div>
                    <div class="ai-price">
                      <span class="ai-price-cur">$</span>
                      <span class="ai-price-val">{{formData.aiCallCenter.pricePerProcessed||0.40}}</span>
                      <span class="ai-price-note">facturé seulement quand une commande IA atteint Processed</span>
                    </div>
                  </div>
                </div>

                <!-- scope -->
                <div class="ai-field">
                  <div class="ai-field-label">Portée</div>
                  <div class="ai-seg">
                    <button type="button" @click="formData.aiCallCenter.scope='all'"
                      :class="{active: formData.aiCallCenter.scope==='all'}" class="ai-seg-btn scope">
                      <b>Toutes les commandes</b><small>tout ce warehouse</small>
                    </button>
                    <button type="button" @click="formData.aiCallCenter.scope='sellers'"
                      :class="{active: formData.aiCallCenter.scope==='sellers'}" class="ai-seg-btn scope">
                      <b>Vendeurs spécifiques</b><small>choisir les boutiques</small>
                    </button>
                  </div>
                </div>

                <!-- Quelles boutiques : une seule liste + un interrupteur.
                     Deux listes separees permettaient a une boutique d'etre a la
                     fois autorisee et bloquee, ce qui n'a aucun sens. -->
                <div class="ai-field" v-if="formData.aiCallCenter.scope==='sellers'">
                  <div class="ai-field-label">Quelles boutiques</div>
                  <div class="ai-seg">
                    <button type="button" @click="setAiSellerMode('only')"
                      :class="{active: (formData.aiCallCenter.sellerMode||'only')==='only'}" class="ai-seg-btn scope">
                      <b>Seulement celles-ci</b><small>l'IA traite ces boutiques</small>
                    </button>
                    <button type="button" @click="setAiSellerMode('except')"
                      :class="{active: formData.aiCallCenter.sellerMode==='except'}" class="ai-seg-btn scope">
                      <b>Toutes sauf celles-ci</b><small>l'IA ignore ces boutiques</small>
                    </button>
                  </div>
                  <v-select class="mt-2" multiple v-model="aiScopeSellers"
                    :options="aiSellers" label="fullName" :reduce="s => s._id"
                    placeholder="Rechercher et choisir des boutiques...">
                    <template #option="o">
                      <div>
                        <div>{{ o.fullName }}</div>
                        <!-- plusieurs comptes partagent le meme nom : l'email les distingue -->
                        <small class="text-gray-400" v-if="o.email">{{ o.email }}</small>
                      </div>
                    </template>
                    <template #no-options>Aucune boutique trouvee.</template>
                  </v-select>
                  <p class="text-xxs text-gray-500 mt-1" v-if="formData.aiCallCenter.sellerMode==='except'">
                    L'IA confirme les commandes de <b>toutes les boutiques sauf</b> celles listees
                    &mdash; leurs commandes vont toujours a un humain. Vide = l'IA traite tout le monde.
                  </p>
                  <p class="text-xxs text-gray-500 mt-1" v-else>
                    L'IA confirme <b>uniquement</b> les commandes des boutiques listees. Vide = aucune.
                  </p>
                </div>

                <!-- adresse de livraison obligatoire -->
                <div class="ai-field">
                  <div class="ai-field-label">Adresse de livraison</div>
                  <div class="ai-seg">
                    <button type="button" @click="formData.aiCallCenter.requireAddress=false"
                      :class="{active: !formData.aiCallCenter.requireAddress}" class="ai-seg-btn scope">
                      <b>Non requise</b><small>peut confirmer sans adresse</small>
                    </button>
                    <button type="button" @click="formData.aiCallCenter.requireAddress=true"
                      :class="{active: formData.aiCallCenter.requireAddress}" class="ai-seg-btn scope">
                      <b>Requise</b><small>jamais confirmer sans adresse</small>
                    </button>
                  </div>
                  <p class="text-xs text-gray-500 mt-2">
                    Si requise : l'IA essaie d'abord l'adresse connue du client (livraisons passées) ;
                    sans adresse fiable, la commande reste en attente pour un appel humain.
                  </p>
                </div>
              </div>
            </div>
            </div>
            <!-- ===== /TAB AGENT IA ===== -->

            <!-- Enregistrer (dans la modale) -->
            <div class="mt-6 pt-3 border-t flex justify-end gap-3">
              <button type="button" @click="$vm2.close('warehouseSettingsModal')" class="rounded px-4 py-2 bg-gray-200 text-gray-700 hover:bg-gray-300 transition-all">{{$t('cancel')||'Annuler'}}</button>
              <button type="button" @click="saveSettingsModal" class="rounded focus:outline-none text-gray-100 px-4 py-2 bg-green-600 hover:shadow-inner hover:bg-green-700 transition-all">{{$t('save')}}</button>
            </div>

          </div>
          </vue-modal-2>
          <!-- ===== /Modale Réglages avancés ===== -->

            <div class="mt-6 pt-3 flex justify-center">
              <button
                @click="save"
                class="rounded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-green-600  hover:shadow-inner hover:bg-green-700  transition-all duration-300"
              >
                {{$t('save')}}
              </button>
            </div>
     
        </div>
    </div>
    <!-- Modal myModalSettings supprimé — les champs pending_unreached sont maintenant directement dans le tab Call Center -->

      <!-- Modal CONFIRM LIVREUR STATUS-->
      <vue-modal-2 name="modalConfirm" :headerOptions="{title: `Confirm date Status: ${params_callcenter_selected.status}`}" :noFooter="true" modalSize="md">
                <div class="flex flex-col w-full h-auto">
                <!-- Header -->
                <div class="bg-white rounded px-2  pb-2 flex flex-col">
                    <p class="font-bold text-center">Veuillez sélectionner propriétés par date  📣</p>
                    <div class="p-5 pb-2">
                        <div class="border border-gray-700 animation-pulse   w-full h-10 hover:border-green-500  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                                <p>
                                    <v-select   placeholder="Sort by date ..."  v-model="sortData" label="name" :options="sort_callcenter" ></v-select>
                                </p>
                         </div>
                    </div>
                    
                    <div class="flex p-2 mt-4">
                        <div class="flex-auto flex flex-row-reverse"> 
                            <button  @click="ConfirmStatus" class="w-1/3 p-3 btn-action rounded bg-blue-600 hover:bg-blue-500 text-white font-semibold focus:outline-none"> Confirm </button>
                            <!-- <button :disabled="loading"  @click="CloseModal('modalConfirm')" class="w-1/3 p-3 mr-4 rounded bg-gray-600 hover:bg-gray-500 text-white font-semibold focus:outline-none"> Annuler</button> -->
                        </div>
                    </div>
                </div>
               </div>
            </vue-modal-2>
         <!-- End Modal CONFIRM LIVREUR STATUS -->

      <!-- ===== Modal AUTO-CONFIRM PREVIEW (data réelle, paginée, à onglets) ===== -->
      <vue-modal-2 name="autoConfirmPreviewModal" :headerOptions="{title: ($t('preview_data')||'Data réelle')}" :noFooter="true" modalSize="lg" @on-close="$vm2.close('autoConfirmPreviewModal')">
        <div class="flex flex-col w-full h-auto p-3" style="min-height:120px">

          <!-- État initial : chargement ou pas encore de data -->
          <div v-if="!autoConfirmPreview" class="text-center text-gray-400 py-10 text-sm">
            {{ autoConfirmPreviewLoading ? ($t('loading')||'Chargement...') : ($t('no_data')||'Aucune donnée') }}
          </div>

          <template v-else>
          <!-- Résumé chiffré -->
          <!-- Mode STRICT : le compteur = commandes réellement auto-confirmables (client seul décide) -->
          <div v-if="autoConfirmPreview.mode==='strict'" class="grid grid-cols-2 gap-2 text-center mb-2">
            <div class="bg-green-50 rounded p-2">
              <div class="text-lg font-bold text-green-600">{{autoConfirmPreview.counts.estimatedConfirmable}}</div>
              <div class="text-xs text-gray-500">{{$t('confirmable')||'Auto-confirmables'}}</div>
            </div>
            <div class="bg-purple-50 rounded p-2">
              <div class="text-lg font-bold text-purple-600">{{autoConfirmPreview.counts.blockedByTransfer}}</div>
              <div class="text-xs text-gray-500">{{$t('blocked_transfer')||'Bloqués (Orange money)'}}</div>
            </div>
          </div>
          <!-- Modes PRODUIT/SELLER : le client seul ne suffit pas -> on montre clients éligibles + produits/vendeurs de confiance, PAS un total trompeur -->
          <div v-else class="mb-2">
            <div class="grid gap-2 text-center" :class="autoConfirmPreview.mode==='phone+product+seller'?'grid-cols-4':'grid-cols-3'">
              <div class="bg-gray-50 rounded p-2">
                <div class="text-lg font-bold text-gray-700">{{autoConfirmPreview.counts.eligible}}</div>
                <div class="text-xxs text-gray-500">{{$t('eligible_customers')||'Clients éligibles'}}</div>
              </div>
              <div class="bg-blue-50 rounded p-2">
                <div class="text-lg font-bold text-blue-700">{{autoConfirmPreview.counts.products}}</div>
                <div class="text-xxs text-gray-500">{{$t('trusted_products')||'Produits de confiance'}}</div>
              </div>
              <div v-if="autoConfirmPreview.mode==='phone+product+seller'" class="bg-green-50 rounded p-2">
                <div class="text-lg font-bold text-green-700">{{autoConfirmPreview.counts.sellersTrusted}}</div>
                <div class="text-xxs text-gray-500">{{$t('trusted_sellers')||'Vendeurs OK'}}</div>
              </div>
              <div class="bg-purple-50 rounded p-2">
                <div class="text-lg font-bold text-purple-600">{{autoConfirmPreview.counts.blockedByTransfer}}</div>
                <div class="text-xxs text-gray-500">{{$t('blocked_transfer')||'Bloqués (Orange money)'}}</div>
              </div>
            </div>
            <p class="text-xxs text-gray-400 mt-2 px-1">{{$t('product_mode_note')||'En mode Produit/Vendeur, une commande est auto-confirmée seulement si le client est éligible ET que TOUS les produits de la commande sont de confiance. Le nombre exact d\'auto-confirmations dépend donc des produits commandés — impossible à totaliser à l\'avance.'}}</p>
          </div>

          <!-- Tabs -->
          <div class="flex flex-wrap gap-1 border-b mb-3">
            <button type="button" v-for="t in autoConfirmTabs" :key="t.key" @click="switchAutoConfirmTab(t.key)"
              :class="autoConfirmTab===t.key ? 'border-green-600 text-green-700 font-semibold' : 'border-transparent text-gray-500 hover:text-gray-700'"
              class="text-xs px-3 py-2 border-b-2 transition-colors">
              {{t.label}} <span class="ml-1 text-xxs bg-gray-100 rounded-full px-1">{{t.count}}</span>
            </button>
          </div>

          <!-- Loading -->
          <div v-if="autoConfirmPreviewLoading" class="text-center text-gray-400 py-6 text-sm">{{$t('loading')||'Chargement...'}}</div>

          <!-- Table dynamique -->
          <div v-else class="overflow-x-auto" style="min-height:200px">
            <table class="w-full text-xs">
              <thead>
                <tr class="text-left text-gray-500 border-b">
                  <!-- CLIENTS -->
                  <template v-if="autoConfirmTab==='customers'">
                    <th class="p-1">{{$t('customer')||'Client'}}</th><th>Tél</th><th>Risk</th><th>{{$t('delivered')||'Livrés'}}</th><th>Ret%</th><th :title="$t('om_rate_title')||'Taux Orange money : commandes passées en Orange money ÷ total commandes × 100'">{{$t('om_rate')||'Orange money %'}}</th><th>{{$t('period')||'Créneau'}}</th>
                  </template>
                  <!-- BLOQUÉS -->
                  <template v-else-if="autoConfirmTab==='blocked'">
                    <th class="p-1">{{$t('customer')||'Client'}}</th><th>Tél</th><th :title="$t('om_count_title')||'Nombre de commandes passées en Orange money (déclenche le blocage)'">{{$t('om_count')||'Cmd. Orange money'}}</th><th :title="$t('om_hardfail_title')||'Commandes passées Orange money puis Annulées (échec définitif)'">{{$t('om_hardfail')||'OM → Annulée'}}</th>
                  </template>
                  <!-- PRODUITS -->
                  <template v-else-if="autoConfirmTab==='products'">
                    <th class="p-1">{{$t('product')||'Produit'}}</th><th>{{$t('shippings')||'Expéditions'}}</th><th>{{$t('delivery_rate')||'Taux livr.'}}</th><th>Ret%</th>
                  </template>
                  <!-- VENDEURS -->
                  <template v-else>
                    <th class="p-1">{{$t('seller')||'Vendeur'}}</th><th>{{$t('shippings')||'Expéditions'}}</th><th>{{$t('delivery_rate')||'Taux livr.'}}</th><th>Ret%</th>
                  </template>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(r,i) in autoConfirmPreview.rows" :key="i" class="border-b hover:bg-gray-50">
                  <template v-if="autoConfirmTab==='customers'">
                    <td class="p-1">{{r.fullName||'—'}}</td>
                    <td>{{r.phoneNormalized}}</td>
                    <td><span class="px-1 rounded text-white text-xxs" :style="{backgroundColor: riskColor(r.riskLevel)}">{{r.riskLevel}}</span></td>
                    <td>{{r.delivered}}</td><td>{{r.returnRate}}%</td><td>{{r.transferRate}}%</td>
                    <td>{{r.preferredDeliveryPeriod==='morning'?'☀️ Matin':(r.preferredDeliveryPeriod==='afternoon'?'🌇 Après-midi':'—')}}</td>
                  </template>
                  <template v-else-if="autoConfirmTab==='blocked'">
                    <td class="p-1">{{r.fullName||'—'}}</td><td>{{r.phoneNormalized}}</td>
                    <td class="text-purple-600 font-medium">{{r.ordersTransferred}}</td>
                    <td>{{r.hardFailedOrders}}</td>
                  </template>
                  <template v-else-if="autoConfirmTab==='products'">
                    <td class="p-1">{{(r.product && r.product.name) || '—'}}</td>
                    <td>{{r.totalShippings}}</td><td>{{r.deliveryRate}}%</td><td>{{r.returnRate}}%</td>
                  </template>
                  <template v-else>
                    <td class="p-1">{{(r.seller && r.seller.fullName) || '—'}}</td>
                    <td>{{r.totalShippings}}</td><td>{{r.deliveryRate}}%</td><td>{{r.returnRate}}%</td>
                  </template>
                </tr>
                <tr v-if="!autoConfirmPreview.rows || !autoConfirmPreview.rows.length">
                  <td :colspan="8" class="py-6 text-center text-gray-400">{{$t('no_data')||'Aucune donnée'}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Pagination -->
          <div v-if="autoConfirmPreview.lastPage > 1" class="flex items-center justify-between mt-4">
            <span class="text-xs text-gray-400">{{autoConfirmPreview.total}} {{$t('results')||'résultats'}} · {{$t('page')||'page'}} {{autoConfirmPreview.page}}/{{autoConfirmPreview.lastPage}}</span>
            <div-paginate :paginate="{currentpage: autoConfirmPreview.page, lastpage: autoConfirmPreview.lastPage, total: autoConfirmPreview.total, per_page: autoConfirmPreview.limit}" @paginatation="changeAutoConfirmPage"></div-paginate>
          </div>
          </template>
        </div>
      </vue-modal-2>
      <!-- ===== End Modal AUTO-CONFIRM PREVIEW ===== -->

      <!-- ===== Modal AIDE : comment marche l'auto-confirm ===== -->
      <vue-modal-2 name="autoConfirmHelpModal" :headerOptions="{title: ($t('how_it_works')||'Comment ça marche ?')}" :noFooter="true" modalSize="lg" @on-close="$vm2.close('autoConfirmHelpModal')">
        <div class="p-4 text-sm text-gray-700 space-y-4">

          <div class="bg-green-50 rounded p-3">
            <p class="font-semibold text-green-800 mb-1">🎯 À quoi ça sert ?</p>
            <p class="text-xs">Au lieu d'envoyer chaque commande au call-center, le système <b>confirme automatiquement</b> les commandes des clients de confiance. Résultat : moins de charge call-center, confirmation instantanée, et livraison planifiée au créneau habituel du client. En cas de doute, la commande reste en <b>Pending</b> et suit le flux normal — l'auto-confirm ne bloque jamais une commande.</p>
          </div>

          <div>
            <p class="font-semibold text-gray-800 mb-1">⚙️ Les 3 modes</p>
            <ul class="text-xs space-y-1 list-disc pl-5">
              <li><b>Strict</b> : on confirme seulement les clients <b>excellents</b> (prouvés fiables). Le plus sûr.</li>
              <li><b>Phone + Produit</b> : on confirme un client correct <b>si tous les produits</b> de la commande sont de confiance.</li>
              <li><b>Phone + Produit + Vendeur</b> : comme ci-dessus, mais on <b>bloque aussi</b> les vendeurs risqués, et on confirme si le vendeur est de confiance.</li>
            </ul>
          </div>

          <div class="bg-gray-50 rounded p-3">
            <p class="font-semibold text-gray-800 mb-2">📐 Comment sont calculés les taux ?</p>
            <p class="text-xs mb-2">Les taux se basent sur les <b>expéditions</b> (shippings) du client / produit / vendeur, pas sur les commandes. On compte :</p>
            <ul class="text-xs space-y-1 list-disc pl-5 mb-3">
              <li><b>Total expéditions</b> = <u>toutes</u> les expéditions, quel que soit le statut (préparée, expédiée, livrée, payée, retournée, annulée…).</li>
              <li><b>Livrées</b> = expéditions au statut <b>« processed »</b> ou <b>« paid »</b> (le client a bien reçu et payé).</li>
              <li><b>Retournées</b> = expéditions au statut <b>« return »</b>.</li>
            </ul>
            <div class="bg-white rounded p-2 text-xs font-mono space-y-1">
              <div>Taux de livraison réussie = <b class="text-green-600">Livrées ÷ Total expéditions × 100</b></div>
              <div>Taux de retour = <b class="text-red-600">Retournées ÷ Total expéditions × 100</b></div>
            </div>
            <p class="text-xs mt-2 text-gray-500">
              <b>Exemple :</b> un client a 10 expéditions au total → 7 livrées (payées), 2 retournées, 1 annulée.<br>
              → Taux de livraison = 7/10 = <b>70%</b> &nbsp;·&nbsp; Taux de retour = 2/10 = <b>20%</b>.<br>
              (Le dénominateur est toujours le <b>total</b> des expéditions, donc les deux taux ne font pas forcément 100% à eux deux — le reste, ce sont les commandes en cours, annulées, etc.)
            </p>
          </div>

          <div>
            <p class="font-semibold text-gray-800 mb-2">📋 Les réglages, un par un</p>
            <table class="w-full text-xs">
              <tbody>
                <tr class="border-b bg-gray-50"><td class="p-1 font-medium whitespace-nowrap" colspan="2">👤 Critères CLIENT</td></tr>
                <tr class="border-b"><td class="p-1 font-medium whitespace-nowrap">Client : min. livraisons <span class="text-gray-400">(strict)</span></td><td class="p-1">Mode <b>strict</b> uniquement. Nombre de commandes <b>livrées</b> qu'un client doit avoir. Ex : 3 = au moins 3 livraisons réussies.</td></tr>
                <tr class="border-b"><td class="p-1 font-medium whitespace-nowrap">Client : max. taux retour <span class="text-gray-400">(strict)</span></td><td class="p-1">Mode <b>strict</b> uniquement. Taux de <b>retour</b> maximum toléré (%) = <i>retournées ÷ total expéditions × 100</i>. Ex : 10 = on refuse un client qui retourne plus de 10% de ses expéditions.</td></tr>
                <tr class="border-b"><td class="p-1 font-medium whitespace-nowrap">Client : min. livraisons <span class="text-gray-400">(produit/vendeur)</span></td><td class="p-1">Modes <b>Produit/Vendeur</b>. Nombre min. de livraisons réussies du client avant de regarder les produits. Ex : 1. <b>0 = accepter tout client</b> (la confiance vient alors uniquement des produits).</td></tr>
                <tr class="border-b bg-gray-50"><td class="p-1 font-medium whitespace-nowrap" colspan="2">📦 Critère PRODUIT (modes produit/vendeur)</td></tr>
                <tr class="border-b"><td class="p-1 font-medium whitespace-nowrap">Produit : min. taux livraison</td><td class="p-1">Un produit est « de confiance » si son taux de livraison réussie ≥ ce seuil (%) = <i>livrées ÷ total expéditions × 100</i>, sur toutes ses expéditions. La commande n'est auto-confirmée que si <b>TOUS</b> ses produits sont de confiance. Ex : 75%.</td></tr>
                <tr class="border-b bg-gray-50"><td class="p-1 font-medium whitespace-nowrap" colspan="2">🔴 Critère VENDEUR (mode +Vendeur seulement)</td></tr>
                <tr class="border-b"><td class="p-1 font-medium whitespace-nowrap">Vendeur risqué : min. expéditions</td><td class="p-1">À partir de combien d'expéditions on évalue si un vendeur est « risqué ». Ex : 5.</td></tr>
                <tr class="border-b"><td class="p-1 font-medium whitespace-nowrap">Vendeur risqué : max. taux retour</td><td class="p-1">Au-delà de ce taux de retour (%), le vendeur est jugé risqué et ses commandes <b>ne sont pas</b> auto-confirmées. Ex : 30%.</td></tr>
                <tr class="border-b bg-yellow-50"><td class="p-1 font-medium whitespace-nowrap" colspan="2">🔴 Garde-fou « Orange money »</td></tr>
                <tr class="bg-yellow-50"><td class="p-1 font-medium whitespace-nowrap">Nb. commandes « Orange money » pour bloquer</td><td class="p-1">Le client n'est <b>PAS</b> auto-confirmé s'il a atteint ce nombre de commandes passées en statut <b>« Orange money »</b> (injoignable / à transférer). Ex : 3. <b>Vide = garde-fou désactivé.</b></td></tr>
                <tr class="border-b bg-gray-50"><td class="p-1 font-medium whitespace-nowrap" colspan="2">⏱ Fenêtres d'activité</td></tr>
                <tr><td class="p-1 font-medium whitespace-nowrap">Activité client / vendeur (mois)</td><td class="p-1">Le client (ou vendeur) doit avoir eu une activité dans les N derniers mois. <b>Vide = pas de limite</b> (tout l'historique compte). Empêche d'auto-confirmer sur une réputation trop ancienne.</td></tr>
              </tbody>
            </table>
          </div>

          <div class="bg-blue-50 rounded p-3">
            <p class="font-semibold text-blue-800 mb-1">💡 Astuce</p>
            <p class="text-xs">Utilisez <b>Quick Setup</b> (conservative / balanced / aggressive) pour remplir des seuils raisonnables, puis cliquez <b>« Voir la data »</b> pour visualiser exactement quels clients / produits / vendeurs seront concernés avant d'enregistrer.</p>
          </div>

        </div>
      </vue-modal-2>
      <!-- ===== End Modal AIDE ===== -->

      <!-- ===== Modal AIDE CALL CENTER ===== -->
      <vue-modal-2 name="callcenterHelpModal" :headerOptions="{title: 'Comment ça marche ?'}" :noFooter="true" modalSize="lg" @on-close="$vm2.close('callcenterHelpModal')">
        <div class="p-5 text-sm text-gray-700 space-y-5">

          <!-- Section 1 : Ordre de traitement -->
          <div>
            <h3 class="font-bold text-gray-800 mb-2 flex items-center gap-1">
              <i class="material-icons text-green-600" style="font-size:18px">format_list_numbered</i>
              Ordre de traitement des commandes
            </h3>
            <p class="mb-2">Quand un agent de confirmation clique sur <b>"Confirmer"</b>, le système lui présente les commandes dans l'ordre que vous définissez ici :</p>
            <div class="bg-gray-50 rounded p-3 space-y-1">
              <div class="flex items-center gap-2">
                <span class="w-5 h-5 rounded-full bg-green-500 text-white text-xs font-bold flex items-center justify-center">1</span>
                <b>A rappeler</b> — Commandes dont l'heure de rappel est arrivée (priorité absolue)
              </div>
              <div class="flex items-center gap-2">
                <span class="w-5 h-5 rounded-full bg-gray-300 text-gray-700 text-xs font-bold flex items-center justify-center">2</span>
                <b>Pending unreached</b> — Commandes déjà appelées mais client injoignable
              </div>
              <div class="flex items-center gap-2">
                <span class="w-5 h-5 rounded-full bg-gray-300 text-gray-700 text-xs font-bold flex items-center justify-center">3</span>
                <b>Pending fresh</b> — Nouvelles commandes jamais appelées
              </div>
            </div>
            <p class="text-xs text-gray-400 mt-2">Le système épuise le type 1 avant de passer au type 2, puis au type 3. <b>Nouvelle date</b> = la commande la plus récente en premier. <b>Ancienne date</b> = la plus ancienne en premier.</p>
          </div>

          <!-- Section 2 : Pending Unreached -->
          <div>
            <h3 class="font-bold text-gray-800 mb-2 flex items-center gap-1">
              <i class="material-icons text-orange-500" style="font-size:18px">phone_missed</i>
              Paramètres Pending Unreached
            </h3>
            <p class="mb-3">Ces paramètres contrôlent comment les commandes "injoignables" sont gérées dans la file de confirmation :</p>

            <div class="space-y-3">
              <div class="flex gap-3 items-start bg-gray-50 rounded p-3">
                <span class="font-bold text-green-600 text-lg leading-none mt-0.5">①</span>
                <div>
                  <b>Appels / jour</b>
                  <p class="text-gray-500 mt-0.5">Nombre max de tentatives par commande par jour. Exemple : si = 3, après 3 appels aujourd'hui la commande disparaît de la file jusqu'à demain. Les commandes avec <b>moins d'appels aujourd'hui sont prioritaires</b> dans la file (triées par nombre croissant).</p>
                </div>
              </div>
              <div class="flex gap-3 items-start bg-gray-50 rounded p-3">
                <span class="font-bold text-blue-600 text-lg leading-none mt-0.5">②</span>
                <div>
                  <b>Délai entre appels (min)</b>
                  <p class="text-gray-500 mt-0.5">Pause minimum entre 2 tentatives sur la même commande. Si = 60, après un appel la commande disparaît pendant 1h puis réapparaît automatiquement.</p>
                </div>
              </div>
              <div class="flex gap-3 items-start bg-gray-50 rounded p-3">
                <span class="font-bold text-orange-500 text-lg leading-none mt-0.5">③</span>
                <div>
                  <b>Max appels total</b>
                  <p class="text-gray-500 mt-0.5">Limite totale d'appels sur toute la vie de la commande. Si = 10, après 10 tentatives (tous jours confondus) la commande <b>sort définitivement</b> de la file et ne sera plus présentée aux agents.</p>
                </div>
              </div>
              <div class="flex gap-3 items-start bg-gray-50 rounded p-3">
                <span class="font-bold text-red-500 text-lg leading-none mt-0.5">④</span>
                <div>
                  <b>Pendant (jours)</b>
                  <p class="text-gray-500 mt-0.5">Nombre de jours en statut Pending Unreached avant que le cron automatique change le statut en <b>Unreached</b> (statut final). Si = 14, la commande reste dans la file pendant 14 jours maximum.</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Section 3 : Exemple -->
          <div class="bg-blue-50 rounded p-3">
            <h3 class="font-bold text-blue-800 mb-1 flex items-center gap-1">
              <i class="material-icons" style="font-size:16px">lightbulb_outline</i>
              Exemple concret
            </h3>
            <p class="text-blue-700 text-xs leading-relaxed">
              Avec <b>Appels/jour = 3</b>, <b>Délai = 60 min</b>, <b>Max total = 10</b>, <b>Pendant = 14 jours</b> :<br>
              → Jour 1 : l'agent appelle 3 fois (espacées d'1h min). La commande disparaît jusqu'à demain.<br>
              → Jour 2 : 3 appels de plus (total = 6).<br>
              → Jour 3 : 3 appels de plus (total = 9).<br>
              → Jour 4 : 1 appel (total = 10) → la commande sort de la file définitivement.<br>
              → Si après 14 jours le max n'est pas atteint, le cron passe la commande en Unreached automatiquement.
            </p>
          </div>

          <div class="flex justify-end pt-2">
            <button type="button" @click="$vm2.close('callcenterHelpModal')" class="px-4 py-2 text-sm bg-green-600 text-white rounded hover:bg-green-500">Compris</button>
          </div>
        </div>
      </vue-modal-2>
      <!-- ===== End Modal AIDE CALL CENTER ===== -->

  </div>

</template>

<script>
export default {
  data() {
    return {
      // liste des vendeurs pour le selecteur de portee de l'IA (chargee a la demande)
      aiSellers: [],
      formData: {
        name: "",
        callcenter:[],
        pending_unreached:{nb_perDay:3,nb_days:4,timeMinutes:90,nbCalls:3},
        autoConfirm_settings: this.defaultAutoConfirmSettings(),
        aiCallCenter: this.defaultAiCallCenter()
      },
      autoConfirmModes:[
        {label:'Strict (client fiable seulement)', value:'strict'},
        {label:'Phone + Produit', value:'phone+product'},
        {label:'Phone + Produit + Vendeur', value:'phone+product+seller'}
      ],
      autoConfirmPresets:null,
      autoConfirmSaving:false,
      autoConfirmPreview:null,       // { counts, tab, page, lastPage, total, rows } de la modale paginée
      autoConfirmPreviewLoading:false,
      autoConfirmActivePreset:null,  // preset cliqué (surlignage)
      autoConfirmTab:'customers',    // onglet actif dans la modale de preview
      settingsTab:'callcenter',      // onglet actif dans la modale Réglages avancés
      options: this.$countries,
      selectContry:"",
      params_callcenter:[{name:'Pending fresh',sort:"-1",key:'pending fresh'},{name:'A rappeler',sort:"-1",key:'pending remind'},{name:'Pending unreached',sort:"-1",key:'pending unreached'}],
      sort_callcenter:[{name:"Nouvelle date",sort:"-1"},{name:"Ancienne date",sort:"1"}],
      sortData:{name:"Nouvelle date",sort:"-1"},
      zones:[],
      selectContryParent:null,
      warehouses:[],
      loading:false,
      fullPage: false,
      params_callcenter_selected:{index:0,status:""}
    };
  },
  watch: {

   'formData.pending_unreached': {
     handler(val){
      console.log('oldVal---',val)
     },
     deep: true
  },
   // Changer de mode : si la modale de preview est déjà chargée, on repart sur l'onglet clients.
   'formData.autoConfirm_settings.mode': function(){
     if(this.autoConfirmPreview){
       this.autoConfirmTab='customers';
       this.fetchAutoConfirmPreview('customers', 1);
     }
   }
  },
  async mounted() {
    await this.getUser();
  //  await this.getZones();
    this.dataToEdit();
    await this.getWarehouses();
  },
  computed: {
    // La seule liste derriere l'interrupteur Seulement/Sauf. Elle lit et ecrit le
    // champ correspondant au mode courant (sellers = liste blanche,
    // blockedSellers = liste noire), donc UN SEUL des deux est jamais rempli et
    // une boutique ne peut pas etre autorisee et bloquee en meme temps.
    aiScopeSellers: {
      get() {
        const ai = (this.formData && this.formData.aiCallCenter) || {};
        const list = ai.sellerMode === 'except' ? ai.blockedSellers : ai.sellers;
        return Array.isArray(list) ? list : [];
      },
      set(val) {
        const ai = this.formData.aiCallCenter;
        const list = Array.isArray(val) ? val : [];
        if (ai.sellerMode === 'except') {
          this.$set(ai, 'blockedSellers', list);
          this.$set(ai, 'sellers', []);
        } else {
          this.$set(ai, 'sellers', list);
          this.$set(ai, 'blockedSellers', []);
        }
      },
    },
    // Onglets de la modale de preview, filtrés selon le mode + counts affichés.
    autoConfirmTabs(){
      if(!this.autoConfirmPreview) return [];
      const c=this.autoConfirmPreview.counts||{};
      const mode=this.autoConfirmPreview.mode||'strict';
      const tabs=[
        {key:'customers', label:(this.$t?this.$t('customers')||'Clients':'Clients'), count:c.eligible||0},
      ];
      if(c.blockedByTransfer>0) tabs.push({key:'blocked', label:(this.$t?this.$t('blocked')||'Bloqués':'Bloqués'), count:c.blockedByTransfer||0});
      if(mode==='phone+product' || mode==='phone+product+seller') tabs.push({key:'products', label:(this.$t?this.$t('products')||'Produits':'Produits'), count:c.products||0});
      if(mode==='phone+product+seller'){
        tabs.push({key:'sellersTrusted', label:(this.$t?this.$t('trusted_sellers')||'Vendeurs OK':'Vendeurs OK'), count:c.sellersTrusted||0});
        tabs.push({key:'sellersRisky', label:(this.$t?this.$t('risky_sellers')||'Vendeurs risqués':'Vendeurs risqués'), count:c.sellersRisky||0});
      }
      return tabs;
    },
  },
  methods: {
    // Basculer Seulement <-> Sauf deplace les boutiques choisies vers l'autre
    // champ, pour que la selection visible soit toujours celle qui sera
    // enregistree (et que le champ inutilise soit vide).
    setAiSellerMode(mode) {
      const ai = this.formData.aiCallCenter;
      if (!ai) return;
      const prev = ai.sellerMode || 'only';
      if (prev === mode) return;
      const carried = (prev === 'except' ? ai.blockedSellers : ai.sellers) || [];
      this.$set(ai, 'sellerMode', mode);
      if (mode === 'except') {
        this.$set(ai, 'blockedSellers', carried);
        this.$set(ai, 'sellers', []);
      } else {
        this.$set(ai, 'sellers', carried);
        this.$set(ai, 'blockedSellers', []);
      }
    },
    async loadAiSellers() {
      if (this.aiSellers.length) return;
      try {
        const res = await this.$server.search('users', { type: 'Seller', limit: 1000 });
        this.aiSellers = (res && res.content && res.content.results) ? res.content.results : [];
      } catch (e) { console.log('loadAiSellers error', e && e.message); }
    },
    ConfirmStatus(){
      console.log('sort data----',this.sortData)
      let dataSelected= this.formData.callcenter[this.params_callcenter_selected.index];
      dataSelected.sort=this.sortData.sort;
      //remove entre parantaise ()
      dataSelected.name=dataSelected.name.replace(/["'(].*["')]/, '');
      dataSelected.name=dataSelected.name+'('+this.sortData.name+')';
      this.$vm2.close('modalConfirm');
    },
    setSelectedStatus(status){
       if(status){
        console.log('id----------',status)
        console.log('callcenter----------',this.formData.callcenter)

          this.params_callcenter_selected.index=this.formData.callcenter.length-1;
          if(this.formData.callcenter.length !== 0){
            
            //set same name in same element selected
            this.formData.callcenter.forEach(elem => {
              if(elem.key === status[status.length-1].key){
                elem.name= this.formData.callcenter.filter(item=> item.key === status[status.length-1].key)[0].name;
              }
            });
           
            //check duplicated element by key selected
            const ids = this.formData.callcenter.map(({ key }) => key);
            const filtered = this.formData.callcenter.filter(({ key }, index) => !ids.includes(key, index + 1));
            this.formData.callcenter=filtered;

            if(this.formData.callcenter.length === status.length){
              this.params_callcenter_selected.status=this.formData.callcenter[this.formData.callcenter.length-1].name;
              this.$vm2.open('modalConfirm');
            }else return false
            
          } 
           
       }
    },
    async CloseModal(id,action){
     console.log('id----------',id)
     console.log('action----------',action)
      if(action === 'close'){
        this.loading=true;
        const editData = await this.$server.get("warehouses", {id: this.$route.params.id,all:true});
        this.loading=false;
        if(editData.content && editData.content.pending_unreached){
            this.formData.pending_unreached=editData.content.pending_unreached;
            // Ensure new fields have defaults if not yet saved in DB
            if(!this.formData.pending_unreached.timeMinutes) this.formData.pending_unreached.timeMinutes=90;
            if(!this.formData.pending_unreached.nbCalls) this.formData.pending_unreached.nbCalls=3;
        }
        else this.formData.pending_unreached={nb_perDay:3,nb_days:4,timeMinutes:90,nbCalls:3}
      }

      this.$vm2.close(id);
    },
    async getWarehouses(){
        const filter = {limit:100};
        const res = await this.$server.search("warehouses",filter);
        if (res && res.content.results) {
            this.warehouses = res.content.results;
        } else this.warehouses = [];
    },
    setSelectedContry(contry){
      if(contry){
        this.formData.country=contry.name;
        this.formData.countryName=contry.name;
        this.selectContry=contry.code;
      }
    },
    async setSelectedParent(contry) {
       if(contry){
         this.formData.parent=contry;
         this.selectContryParent=contry.code;
         await this.getZones(contry.country);
       }else {this.formData.parent=null;this.formData.zones=[];}
    },
    async save() {
      if (this.formData._id) {
          this.formData.country=this.selectContry;
          if(this.checkData()) {
              this.formData.flag = this.$f.getCountryCode(this.selectContry);
              this.formData.callcenter.sort=this.sortData.sort;
              const data = await this.$server.update("warehouses", this.formData);
              this.formData.country=this.$f.getCountryNameByCode(this.options,this.selectContry);
              if (data._id) {
                alert(this.$t('warehouse_updated'), "success");
              }else alert(data ,"warning");
          }else alert(this.$t('all_required_field'), "warning");
        
      } else {
          if (this.checkData()) {
              this.formData.country=this.selectContry;
              this.formData.flag = this.$f.getCountryCode(this.selectContry);
              this.formData.callcenter.sort=this.sortData.sort;
              const data = await this.$server.create("warehouses", this.formData);
              this.formData.country=this.$f.getCountryNameByCode(this.options,this.selectContry);
              if (data._id) {
                alert(this.$t('warehouse_created'), "success");
                this.formData.name= this.formData.country =this.selectContry= "";
              }else alert(data ,"warning");
          } else alert(this.$t('all_required_field'), "warning");
      }
    },
    emtyTabId(){
      let columns = document.querySelectorAll('.form-checkbox');
      columns.forEach(column => {column.checked = false});
      delete formData.zone;
    },
     async getRowDetail(id) {
        // let rows = this.selectedRows;
        //console.log('.rowCheckboxZone-'+id)
        let columns = document.querySelectorAll('.form-checkbox');
        let element = document.querySelector('.rowCheckboxZone-'+id);
        columns.forEach(column => {column.checked = false});
        element.checked = true;
        this.formData.zone=id;
       // console.log('formdate______________',this.formData)
     
    },
    checkData() {
      if (
        this.formData.name &&
        this.formData.country 
      ) {
        return true;
      } else {
        return false;
      }
    },
    async getUser() {
      const res = await this.$server.me("users");
      if (res.content) this.currentUser = res.content;
      else this.currentUser = {};
      //console.log(this.currentUser);
    },
    async getZones(country) {
      console.log('country-----',country)
     const zones = await this.$server.search("zones", {limit:40,country:country});
     if(zones && zones.content.results){
       this.zones=zones.content.results;
     }else  this.zones=[];
    },
    // Ouvre la modale Réglages avancés sur l'onglet demandé.
    openSettingsModal(tab){
      this.settingsTab = tab || 'callcenter';
      this.$vm2.open('warehouseSettingsModal');
    },
    // Enregistre depuis la modale puis la referme.
    async saveSettingsModal(){
      // Les champs numériques vidés valent "" (v-model.number) -> cast error Mongoose.
      // On les remet à null (= désactivé) avant l'enregistrement.
      const ac=this.formData.autoConfirm_settings;
      if(ac){
        ['strictDateRangeMonths','relaxedDateRangeMonths','productDateRangeMonths','sellerRiskyDateRangeMonths','maxTransferRate','maxAmountFirsttimer'].forEach(k=>{
          if(ac[k]==='' || ac[k]===undefined || Number.isNaN(ac[k])) ac[k]=null;
        });
      }
      await this.save();
      this.$vm2.close('warehouseSettingsModal');
    },
    defaultAutoConfirmSettings() {
      return {
        enabled:false,
        mode:'strict',
        maxAmountFirsttimer:null,
        strictMinDelivered:3, strictMaxReturnRate:10,
        relaxedMinDelivered:1, relaxedMaxReturnRate:25,
        sellerRiskyMinShippings:5, sellerRiskyMaxReturnRate:30,
        productTrustedMinShippings:20, productTrustedMinDeliveryRate:75,
        strictDateRangeMonths:null, relaxedDateRangeMonths:null,
        productDateRangeMonths:null, sellerRiskyDateRangeMonths:null,
        maxTransferRate:null, minTransferOrders:3,
        sms:{ enabled:false, senderName:null, template:"Bonjour {customerName}, votre commande #{orderId} a ete confirmee. Vous serez contacte pour la livraison. Merci !" }
      };
    },
    defaultAiCallCenter() {
      return {
        active:false, mode:'shadow', threshold:0.85, pricePerProcessed:0.40,
        scope:'all', sellers:[], blockedSellers:[], sellerMode:'only',
        maxAmountAiConfirm:null, requireAddress:false
      };
    },
    async loadAutoConfirmPresets() {
      try {
        this.autoConfirmSaving=true;
        const country=this.selectContry;
        if(!country) return;
        const res=await this.$server.computeAutoConfirmPresets("analytics", { country });
        this.autoConfirmPresets=res && res.content ? res.content : res;
        this.detectActivePreset();
      } catch(e){ console.log('presets error',e); }
      finally{ this.autoConfirmSaving=false; }
    },
    // Valeurs par défaut si les percentiles n'ont pas encore été calculés (bouton "Recalculer").
    fallbackPresets(){
      return {
        conservative:{ minTransferOrders:2, strictMinDelivered:3, strictMaxReturnRate:10, productTrustedMinDeliveryRate:85 },
        balanced:{ minTransferOrders:3, strictMinDelivered:2, strictMaxReturnRate:15, productTrustedMinDeliveryRate:75 },
        aggressive:{ minTransferOrders:4, strictMinDelivered:1, strictMaxReturnRate:20, productTrustedMinDeliveryRate:65 },
      };
    },
    applyAutoConfirmPreset(name) {
      // Utilise les percentiles calculés si dispo, sinon les valeurs par défaut.
      const src=(this.autoConfirmPresets && this.autoConfirmPresets.presets) ? this.autoConfirmPresets.presets : this.fallbackPresets();
      const p=src[name];
      if(!p) return;
      this.formData.autoConfirm_settings=Object.assign({}, this.formData.autoConfirm_settings, p);
      this.autoConfirmActivePreset=name;
      alert(this.$t ? this.$t('preset_applied') : 'Preset applied', 'success');
    },
    // Détecte si les seuils actuels correspondent exactement à un preset (pour ré-afficher le surlignage à l'ouverture).
    detectActivePreset(){
      const s=this.formData.autoConfirm_settings; if(!s){ this.autoConfirmActivePreset=null; return; }
      const src=(this.autoConfirmPresets && this.autoConfirmPresets.presets) ? this.autoConfirmPresets.presets : this.fallbackPresets();
      const keys=['minTransferOrders','strictMinDelivered','strictMaxReturnRate','productTrustedMinDeliveryRate'];
      const match=Object.keys(src).find(name=>keys.every(k=>Number(s[k])===Number(src[name][k])));
      this.autoConfirmActivePreset=match||null;
    },
    // Ouvre la modale AVANT le fetch (sinon le slot est vide -> "Content here").
    async openAutoConfirmPreview() {
      if(!this.selectContry) { alert(this.$t?this.$t('select_country_first')||'Sélectionnez un pays':'Select a country', 'warning'); return; }
      this.autoConfirmTab='customers';
      this.autoConfirmPreviewLoading=true;
      this.$vm2.open('autoConfirmPreviewModal');
      // au tick suivant pour que la modale soit montée avant le rendu du contenu
      this.$nextTick(()=>{ this.fetchAutoConfirmPreview('customers', 1); });
    },
    async switchAutoConfirmTab(tab){
      if(this.autoConfirmTab===tab) return;
      this.autoConfirmTab=tab;
      await this.fetchAutoConfirmPreview(tab, 1);
    },
    changeAutoConfirmPage(dir){
      if(!this.autoConfirmPreview) return;
      let page=this.autoConfirmPreview.page || 1;
      page = dir==='next' ? page+1 : page-1;
      if(page<1 || page>this.autoConfirmPreview.lastPage) return;
      this.fetchAutoConfirmPreview(this.autoConfirmTab, page);
    },
    // Requête paginée : un onglet + une page à la fois. Les counts reviennent à chaque appel (légers).
    async fetchAutoConfirmPreview(tab, page) {
      const country=this.selectContry;
      if(!country) return;
      const ac=this.formData.autoConfirm_settings||{};
      this.autoConfirmPreviewLoading=true;
      try {
        const payload={
          country,
          mode: ac.mode||'strict',
          tab: tab||'customers',
          page: page||1,
          limit: 20,
          strictMinDelivered: ac.strictMinDelivered,
          strictMaxReturnRate: ac.strictMaxReturnRate,
          relaxedMinDelivered: ac.relaxedMinDelivered,
          productTrustedMinDeliveryRate: ac.productTrustedMinDeliveryRate,
          sellerRiskyMinShippings: ac.sellerRiskyMinShippings,
          sellerRiskyMaxReturnRate: ac.sellerRiskyMaxReturnRate,
          minTransferOrders: ac.minTransferOrders,
          // Fenêtres d'activité — mêmes réglages que le gate (sinon la preview surestime)
          strictDateRangeMonths: ac.strictDateRangeMonths,
          sellerRiskyDateRangeMonths: ac.sellerRiskyDateRangeMonths,
        };
        const res=await this.$server.previewAutoConfirmProfiles("analytics", payload);
        this.autoConfirmPreview=res && res.content ? res.content : res;
      } catch(e){ console.log('preview error',e); }
      finally{ this.autoConfirmPreviewLoading=false; }
    },
    riskColor(level){
      const m={excellent:'#16a34a',low:'#0ea5e9',neutral:'#6b7280',medium:'#f59e0b',high:'#ef4444',new:'#9ca3af',pending:'#9ca3af'};
      return m[level]||'#6b7280';
    },
    async dataToEdit() {
      if (this.$route.params.id) {
        const editData = await this.$server.get("warehouses", {
          id: this.$route.params.id,all:true
        });
        this.formData = editData.content;
        console.log('formData-------',this.formData)
        this.selectContry=this.formData.country;
        this.formData.country=this.$f.getCountryNameByCode(this.options,this.formData.country);
        if(!this.formData.callcenter) this.formData.callcenter={}
        else{
          if(this.formData.callcenter && this.formData.callcenter.name){
            if(this.formData.callcenter.sort.toString() === '-1')  this.sortData={name:"Nouvelle date",sort:"-1"};
            else this.sortData={name:"Ancienne date",sort:"1"};
           }
        }

       

        if(!this.formData.pending_unreached) this.formData.pending_unreached={nb_perDay:3,nb_days:4,timeMinutes:90,nbCalls:3}
        else{
            if(!this.formData.pending_unreached.timeMinutes) this.formData.pending_unreached.timeMinutes=90;
            if(!this.formData.pending_unreached.nbCalls) this.formData.pending_unreached.nbCalls=3;
        }
        // Guard auto-confirm : Mongoose peut renvoyer l'objet incomplet
        if(!this.formData.autoConfirm_settings) this.formData.autoConfirm_settings=this.defaultAutoConfirmSettings();
        else this.formData.autoConfirm_settings=Object.assign(this.defaultAutoConfirmSettings(), this.formData.autoConfirm_settings, {sms: Object.assign(this.defaultAutoConfirmSettings().sms, this.formData.autoConfirm_settings.sms||{})});
        // AI Call-Center agent config (defaults when absent so the toggle binds cleanly)
        if(!this.formData.aiCallCenter) this.formData.aiCallCenter=this.defaultAiCallCenter();
        else this.formData.aiCallCenter=Object.assign(this.defaultAiCallCenter(), this.formData.aiCallCenter);
        // Deduire l'interrupteur Seulement/Sauf de ce qui a ete enregistre, pour
        // qu'une liste noire existante se rouvre du bon cote.
        if(!this.formData.aiCallCenter.sellerMode){
          const bl=this.formData.aiCallCenter.blockedSellers;
          this.$set(this.formData.aiCallCenter,'sellerMode',(Array.isArray(bl)&&bl.length)?'except':'only');
        }
        this.loadAiSellers();
        this.detectActivePreset();
        if(this.formData.parent) await this.getZones(this.formData.parent.country);
        // Calcule les seuils suggérés en arrière-plan (les presets/counts s'affichent sans clic).
        if(!this.formData.parent && this.selectContry) this.loadAutoConfirmPresets();
        //  let columns = document.querySelectorAll('.form-checkbox');
        // let element = document.querySelector('.rowCheckboxZone-'+editData.content.zone);
        // columns.forEach(column => {column.checked = false});
        // element.checked = true;
      }
    },
    /*************************************************************** */
    /**************************************************************/
  },
};
</script>

<style scoped>
/* settings entry card: the way into the modal, and a live summary of what is
   actually confirming orders here */
.whx-entry{ display:flex; align-items:center; gap:14px; margin:28px auto 0; max-width:640px;
  padding:16px 18px; background:#fff; border:1px solid #eef1f5; border-radius:14px;
  cursor:pointer; transition:border-color .15s ease, box-shadow .15s ease, transform .15s ease; }
.whx-entry:hover{ border-color:#bbf7d0; box-shadow:0 6px 20px -10px rgba(5,150,105,.35); transform:translateY(-1px); }
.whx-entry-ico{ flex:none; width:40px; height:40px; border-radius:11px; display:grid; place-items:center;
  background:#ecfdf5; color:#047857; border:1px solid #d1fae5; }
.whx-entry-txt{ min-width:0; flex:1; }
.whx-entry-t{ font-size:13.5px; font-weight:700; color:#111827; }
.whx-entry-s{ font-size:11.5px; color:#9ca3af; margin-top:1px; }
.whx-entry-pills{ display:flex; flex-wrap:wrap; gap:5px; margin-top:9px; }
/* one pill per engine: green = acting, amber = watching only, grey = off */
.whx-p{ font-size:10.5px; font-weight:700; border-radius:9999px; padding:2px 9px;
  border:1px solid; white-space:nowrap; }
.whx-p.on{ background:#ecfdf5; color:#047857; border-color:#a7f3d0; }
.whx-p.watch{ background:#fffbeb; color:#b45309; border-color:#fde68a; }
.whx-p.off{ background:#f3f4f6; color:#9ca3af; border-color:#e5e7eb; }
.whx-entry-arrow{ flex:none; color:#cbd5e1; }
.whx-entry:hover .whx-entry-arrow{ color:#047857; }

/* ===== settings modal (whx-) =====
   Same language as the Auto-Confirm Analytics section (.acx-): #eef1f5 borders,
   #6b7280 uppercase labels, 12px radii - so the two surfaces read as one system. */
.whx-tabs{ display:flex; gap:6px; padding:4px; margin-bottom:20px;
  background:#f6f8fa; border:1px solid #eef1f5; border-radius:12px; }
.whx-tab{ display:flex; align-items:center; gap:7px; padding:8px 14px; font:inherit; font-size:12.5px;
  font-weight:600; color:#6b7280; background:none; border:1px solid transparent; border-radius:9px; cursor:pointer;
  transition:background .15s ease, color .15s ease; }
.whx-tab:hover{ color:#374151; background:rgba(255,255,255,.7); }
.whx-tab.on{ background:#fff; color:#065f46; border-color:#d1fae5; font-weight:700;
  box-shadow:0 1px 2px rgba(15,23,42,.06); }
.whx-tab svg{ flex:none; }
.whx-sub{ font-size:10px; font-weight:600; color:#9ca3af; text-transform:uppercase; letter-spacing:.04em; }
/* a running engine gets a dot: green = acting, amber = watching only */
.whx-dot{ flex:none; width:7px; height:7px; border-radius:50%; }
.whx-dot.on{ background:#10b981; }
.whx-dot.watch{ background:#f59e0b; }

.whx-panel{ background:#fff; border:1px solid #eef1f5; border-radius:12px; overflow:hidden; }
.whx-panel-h{ display:flex; flex-direction:column; gap:2px; padding:10px 14px;
  background:#f8fafc; border-bottom:1px solid #eef1f5; }
.whx-panel-t{ font-size:11px; font-weight:800; text-transform:uppercase; letter-spacing:.05em; color:#374151; }
.whx-panel-n{ font-size:11px; color:#9ca3af; }
.whx-panel-b{ padding:14px; }

.whx-quick{ background:linear-gradient(180deg,#f0fdf4,#f8fafc); border:1px solid #bbf7d0;
  border-radius:12px; padding:14px 16px; }
.whx-quick-t{ font-size:11px; font-weight:800; text-transform:uppercase; letter-spacing:.05em; color:#047857; }

 .form-control-3 {
    position: relative;
    z-index: 2;
    float: left;
    width: 100%;
    margin-bottom: 0;
    cursor: pointer;
    background-color: #eee;
    opacity: 1;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857143;
    color: #555;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
    -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
    -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
}
.form-checkbox:checked {
    background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M5.707 7.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L7 8.586 5.707 7.293z'/%3e%3c/svg%3e");
    border-color: transparent;
    background-color: currentColor;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
}
.items {
    display: flex;
    flex-direction: column;
    padding: 10px;
    counter-reset: done-items undone-items;
}
/* .items input {
    display: block;
    height: 53px;
    margin: 0 0 -53px -9999px;
    outline: none;
    counter-increment: done-items;
} */
.items input:checked + label {
    -webkit-animation: done .5s;
    animation: done .5s;
}
.items label{
  position: relative;
  display: block;
  position: relative;
  padding: 15px 0 15px 15px;
  border-top: 1px dashed #e2e8f0;
  cursor: pointer;
  -webkit-animation: undone .5s;
  animation: undone .5s;
}
.items label:first-child{
  border-top:inherit
}
.items label i {
    display: block;
    position: absolute;
    top: 11px;
    left: 10px;
}
.flag-img {
  display: inline-block;
  height: 16px;
  width: 16px;
  vertical-align: text-top;
  line-height: 16px;
  margin-right: 5px;
}
.tag_cities {
  width: 100%;
  max-width: 100%;
}
.vs__dropdown-toggle {
  border: none;
}
.tag_cities .tag {
  background: rgb(49 130 206 / 16%);
  border-radius: 20px;
  float: left;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 0.8rem;
  font-weight: 500;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-right: 2px;
  margin-bottom: 5px;
  min-height: 28px;
  padding-right: 10px;
  color: rgba(0, 0, 0, 0.7);
  position: relative;
  padding-right: 0;
}
.vs-chip--text {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-left: 10px;
}
.vs-chip--close {
  width: 20px;
  height: 20px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-radius: 50%;
  border: 0;
  margin: 0 4px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.15);
  color: #fff;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  cursor: pointer;
}
.tag_cities .tag [data-role="remove"]::after {
  content: "x";
  padding: 0px 2px;
  margin-bottom: 3px;
  font-size: 15px;
}
.tag_cities .tag [data-role="remove"] {
  margin-left: 8px;
  cursor: pointer;
}
.top-100 {
  top: 100%;
}

.bottom-100 {
  bottom: 100%;
}

.max-h-select {
  max-height: 300px;
}
/* Callcenter v-select */
.callcenter-select .vs__dropdown-toggle {
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  min-height: 38px;
}
.callcenter-select .vs__dropdown-toggle:hover,
.callcenter-select.vs--open .vs__dropdown-toggle {
  border-color: #48bb78;
}

/* ============ AI Call-Center Agent panel (separate "Agent IA" tab) ============ */
/* Uses the app's PRIMARY = green (Tailwind green-600 #16a34a / green-700 #15803d),
   matching the sidebar, buttons, and the rest of the UI. Own "Agent IA" tab. */
.ai-panel{ border:1px solid #bbf7d0; border-radius:16px; overflow:hidden; background:#fdfffe;
  box-shadow:0 6px 22px -14px rgba(22,163,74,.22); }
.ai-panel-head{ display:flex; align-items:flex-start; gap:14px; padding:18px 20px;
  background:linear-gradient(120deg,#f0fdf4 0%,#fafffb 70%); border-bottom:1px solid #dcfce7; }
.ai-avatar{ width:44px; height:44px; border-radius:13px; flex-shrink:0; display:flex; align-items:center;
  justify-content:center; font-size:22px; background:linear-gradient(150deg,#16a34a,#15803d);
  box-shadow:0 5px 16px -4px rgba(22,163,74,.5); }
.ai-head-txt{ flex:1; min-width:0; }
.ai-head-title{ font-size:15.5px; font-weight:800; color:#15803d; letter-spacing:-.01em; }
.ai-chip{ font-size:10px; font-weight:700; text-transform:uppercase; letter-spacing:.05em; color:#16a34a;
  background:#dcfce7; border:1px solid #bbf7d0; padding:1px 8px; border-radius:20px; margin-left:6px; vertical-align:middle; }
.ai-head-sub{ font-size:12.5px; color:#5f6f64; line-height:1.5; margin-top:3px; }
.ai-head-sub b{ color:#15803d; font-weight:700; }

/* on/off switch in the header */
.ai-switch{ flex-shrink:0; cursor:pointer; margin-top:4px; }
.ai-switch-track{ display:block; width:44px; height:24px; border-radius:20px; background:#d4e5d9; position:relative; transition:background .2s; }
.ai-switch-dot{ position:absolute; top:2px; left:2px; width:20px; height:20px; border-radius:50%; background:#fff;
  box-shadow:0 1px 3px rgba(0,0,0,.25); transition:transform .2s; }
.ai-switch.on .ai-switch-track{ background:#16a34a; }
.ai-switch.on .ai-switch-dot{ transform:translateX(20px); }
.sr-only{ position:absolute; width:1px; height:1px; padding:0; margin:-1px; overflow:hidden; clip:rect(0,0,0,0); border:0; }

/* the 2-step flow: native first, AI second (both green — same primary, numbered order shows sequence) */
.ai-flow{ display:flex; align-items:center; gap:10px; padding:12px 20px; background:#fafffb; border-bottom:1px solid #dcfce7;
  font-size:11.5px; flex-wrap:wrap; }
.ai-flow-step{ padding:5px 11px; border-radius:8px; font-weight:700; }
.ai-flow-step em{ font-weight:500; font-style:normal; opacity:.8; }
.ai-flow-step.native{ background:#f1f5f9; color:#475569; border:1px solid #e2e8f0; }
.ai-flow-step.ai{ background:#dcfce7; color:#15803d; border:1px solid #bbf7d0; }
.ai-flow-arrow{ color:#9cc4a8; font-weight:800; }

.ai-panel-body{ padding:20px; display:flex; flex-direction:column; gap:20px; }
.ai-field-label{ font-size:11px; font-weight:700; text-transform:uppercase; letter-spacing:.04em; color:#5f6f64; margin-bottom:8px; display:flex; align-items:center; gap:8px; }
.ai-val{ color:#16a34a; font-size:13px; }
.ai-fixed{ font-size:9.5px; font-weight:700; text-transform:uppercase; color:#7f8f84; background:#eef6f0; border:1px solid #d4e5d9; padding:1px 7px; border-radius:20px; letter-spacing:.03em; }

/* segmented buttons (mode / scope) */
.ai-seg{ display:flex; gap:8px; }
.ai-seg-btn{ flex:1; display:flex; flex-direction:column; align-items:center; gap:2px; padding:10px 8px; border-radius:10px;
  border:1.5px solid #d4e5d9; background:#fff; cursor:pointer; transition:all .16s; color:#5f6f64; }
.ai-seg-btn b{ font-size:13px; font-weight:700; }
.ai-seg-btn small{ font-size:10.5px; opacity:.75; }
.ai-seg-btn:hover{ border-color:#86efac; }
.ai-seg-btn.scope.active, .ai-seg-btn.live.active{ background:#16a34a; border-color:#16a34a; color:#fff; }
.ai-seg-btn.shadow.active{ background:#6b7280; border-color:#6b7280; color:#fff; } /* shadow = neutral grey (safe/free) */

.ai-warn{ font-size:12px; color:#92400e; background:#fffbeb; border:1px solid #fde9c8; border-radius:9px; padding:9px 12px; margin-top:10px; line-height:1.5; }
.ai-warn code{ font-family:monospace; font-size:11px; background:#fef3c7; padding:1px 5px; border-radius:4px; }

.ai-grid{ display:grid; grid-template-columns:1fr 1fr; gap:18px; }
@media (max-width:560px){ .ai-grid{ grid-template-columns:1fr; } }

/* range slider (green) */
.ai-range{ width:100%; accent-color:#16a34a; }
.ai-range-scale{ display:flex; justify-content:space-between; font-size:10px; color:#a3c4ac; margin-top:4px; }

/* price card (amber money) */
.ai-price{ display:flex; align-items:baseline; gap:4px; flex-wrap:wrap; background:linear-gradient(180deg,#fffdf5,#fffbeb);
  border:1px solid #fde9c8; border-radius:10px; padding:10px 14px; }
.ai-price-cur{ font-size:16px; font-weight:700; color:#b45309; }
.ai-price-val{ font-size:24px; font-weight:800; color:#b45309; line-height:1; }
.ai-price-note{ font-size:10.5px; color:#a1854a; width:100%; margin-top:3px; }

.text-xxs{ font-size:10px; }
</style>